import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { faHome } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent implements OnInit {

  faHome = faHome;
  errorMsg: string;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    // tslint:disable-next-line: deprecation
    this.route.paramMap.subscribe( val => {
      console.log(val.get('status'));
      switch (val.get('status')) {
        case '403':
          this.errorMsg = 'APPLICATION.ERRORS.403';
          break;
        case '401':
          this.errorMsg = 'APPLICATION.ERRORS.401';
          break;
        case '400':
          this.errorMsg = 'APPLICATION.ERRORS.400';
          break;
        default :
          this.errorMsg = 'APPLICATION.ERRORS.GENERIC';
          break;
      }
    });
  }

}
